<template>
  <div>
    <nav class="navbar container navbar-expand-lg navbar-light" >
      <a class="navbar-brand mx-auto d-none d-md-block" href="#">
        <img 
          class="" 
          src="static/img/header_uanl_facdyc.png" 
          alt="Facultad de Derecho y Criminologia" />
      </a>
      <a class="navbar-brand mx-auto d-block d-md-none" href="#">
        <img class="img-fluid" src="static/img/logo_facdyc.png" alt="">
      </a>
    </nav>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      opcion_activa:'Login'
    }
  },
  methods:{
    Login(){
      this.opcion_activa='Login';
      this.$router.push({name:'Login'});
    }
  },
  created(){
    if (this.$route.name=='MenuPrincipal') {
      this.Login();
    }else{
      this.$router.push({name:this.$route.name});
    }
  }
};
</script>

<style scoped>
li.active{
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPrincipal.vue